<template>
  <div class="smart-detection-over-view">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="smart-detection-over-view-table-main" style="margin-top: 20px">
      <el-tabs type="border-card" v-model="operationMonitoring">
        <el-tab-pane label="运行参数" name="operatingParameters">
          <table-main :selection="false" tableWidth="1800px" :tableHead="operatingParametersTableHead" :tableData="operatingParametersTableData" :pagination="false" @changePagination="changePagination" :hasOperation="false"/>
        </el-tab-pane>
        <el-tab-pane label="回路状态" name="loopState">
          <table-main :selection="false" :tableHead="loopStateTableHead" :tableData="loopStateTableData" :pagination="false" @changePagination="changePagination" :hasOperation="false"/>
        </el-tab-pane>
        <el-tab-pane label="电容温度" name="capacitanceTemperature">
          <table-main :selection="false" :tableHead="capacitanceTemperatureTableHead" :tableData="capacitanceTemperatureTableData" :pagination="false" @changePagination="changePagination" :hasOperation="false"/>
        </el-tab-pane>
      </el-tabs>
    </div>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import { api } from "../../api/SmartDetection";
import TableMain from "../../../components/Table/TableMain";
import { nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
import OverViewTopLine from "../../../components/OverView/OverViewTopLine";
export default {
  name: "SmartDetectionOperationMonitoring",
  components: { OverViewTopLine, TableMain, Breadcrumb },
  data() {
    return {
      breadcrumb: [
        {
          value: "配电监测",
          name: "smart-detection-over-view"
        },
        {
          value: "配电监测"
        }
      ],
      transformerList: [],

      operationMonitoring: "operatingParameters",

      total: 0,
      pageSize: 10,
      pageNum: 1,
      operatingParametersTableData: [],
      operatingParametersTableHead: [
        {
          prop: "name",
          label: "回路名称",
          width: '120px',
        },
        {
          prop: "account",
          label: "回路编号",
          width: '120px',
        },
        {
          prop: "zswitch",
          label: "运行状态",
          width: '120px',
        },
        {
          prop: "ua",
          label: "A相实时电压/V",
          width: '120px',
        },
        {
          prop: "ub",
          label: "B相实时电压/V",
          width: '120px',
        },
        {
          prop: "uc",
          label: "C相实时电压/V",
          width: '120px',
        },
        {
          prop: "ia",
          label: "A相实时电流/A",
          width: '120px',
        },
        {
          prop: "ib",
          label: "B相实时电流/A",
          width: '120px',
        },
        {
          prop: "ic",
          label: "C相实时电流/A",
          width: '120px',
        },
        {
          prop: "ta",
          label: "A相温度/℃",
          width: '120px',
        },
        {
          prop: "tb",
          label: "B相温度/℃",
          width: '120px',
        },
        {
          prop: "tc",
          label: "C相温度/℃",
          width: '120px',
        },
        {
          prop: "p",
          label: "有功功率/kW",
          width: '120px',
        },
        {
          prop: "q",
          label: "无功功率/kVar",
          width: '120px',
        },
        {
          prop: "ir",
          label: "额定电流/A",
          width: '120px',
        },
        {
          prop: "rc",
          label: "剩余电流/mA",
          width: '120px',
        },
        {
          prop: "cosq",
          label: "功率因数",
          width: '120px',
        },
        {
          prop: "rateText",
          label: "负载率",
          width: '120px',
        }
      ],

      loopStateTableData: [],
      loopStateTableHead: [
        {
          prop: "name",
          label: "回路"
        },
        {
          prop: "vswitch",
          label: "运行状态"
        }
      ],

      capacitanceTemperatureTableData: [],
      capacitanceTemperatureTableHead: [
        {
          prop: "name",
          label: "回路"
        },
        {
          prop: "tb",
          label: "温度/℃"
        }
      ]
    };
  },
  created() {
    this.getSiteRunMonitor();
  },
  activated() {
    this.getSiteRunMonitor();
  },
  methods: {
    // 获取运行监测数据
    getSiteRunMonitor() {
      this.$axios
        .post(api.getPowerRunMonitorRunMonitor, {})
        .then(res => {
          let data = res.data.data;
          // data.lineParam.map(v => {
          //   v.rateText = `${v.rate}%`;
          // });
          // this.operatingParametersTableData = data.lineParam || [];
          // this.loopStateTableData = data.lineType || [];
          // this.capacitanceTemperatureTableData = data.lineTemperature || [];
        })
        .catch(errorHandler("获取运行监测数据失败"));
    },

    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    }
  }
};
</script>

<style scoped lang="less">
.smart-detection-over-view {
  .transformer-line {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: center;
    margin: 20px 0;
    .transformer-line-item {
      width: 46%;
      margin: 0 2% 20px;
      padding: 10px 0;
      border: 1px solid rgb(220, 223, 230);
      box-shadow: rgba(0, 0, 0, 0.12) 0px 2px 4px 0px,
        rgba(0, 0, 0, 0.04) 0px 0px 6px 0px;
      .transformer-line-item-top {
        padding: 0 20px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid rgb(220, 223, 230);
      }
      .transformer-line-item-main {
        margin-top: 20px;
        padding: 0 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .transformer-line-item-main-load-rate {
          width: 30%;
          position: relative;
          .transformer-line-item-main-load-rate-img {
            width: 100%;
          }
          .transformer-line-item-main-load-rate-tip {
            width: 100%;
            height: 20px;
            font-size: 12px;
            line-height: 20px;
            position: absolute;
            left: 0;
            bottom: 0;
            color: #2cd5ef;
            background: #e5f8fb;
          }
        }
        .transformer-line-item-main-voltage {
          width: 20%;
          font-size: 14px;
          div {
            line-height: 20px;
          }
        }
        .transformer-line-item-main-electric-current {
          width: 20%;
          font-size: 14px;
          div {
            line-height: 20px;
          }
        }
        .transformer-line-item-main-environment {
          width: 20%;
          font-size: 14px;
          div {
            line-height: 30px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/SmartDetection/SmartDetectionOperationMonitoring/SmartDetectionOperationMonitoring.vue